import "../../api/types.js";
import "immer";
import { ReferralAmountUpdateType } from "../../contract/pam.js";
import "moment-timezone";
import "react-intl";
import "@apollo/client/errors";
import "rxjs";
import "rxjs/operators";
import { EntityBaseGqlService } from "../../api/EntityBaseGqlService.js";
import "@apollo/client";
import "graphql";
import "@opentelemetry/api";
import "../../otel/TraceProvider.js";
import "react";
import "react-error-boundary";
import { map } from "../../otel/rxjs.js";
import "@opentelemetry/context-zone";
import "@opentelemetry/exporter-trace-otlp-http";
import "@opentelemetry/instrumentation";
import "@opentelemetry/instrumentation-document-load";
import "@opentelemetry/instrumentation-xml-http-request";
import "@opentelemetry/resources";
import "@opentelemetry/sdk-trace-web";
import "@opentelemetry/semantic-conventions";
import "@apollo/client/link/subscriptions";
import "@apollo/client/utilities";
import "cross-fetch";
import "graphql-ws";
import "../../node_modules/moment/dist/moment.js";
import "rxjs/ajax";
import { PlayerReferralRequestBuilder } from "./requestBuilder.js";
var ReferrerType = /* @__PURE__ */ ((ReferrerType2) => {
  ReferrerType2["Affiliate"] = "Affiliate";
  ReferrerType2["P2P"] = "P2P";
  return ReferrerType2;
})(ReferrerType || {});
class UserReferralFormModel {
  referrer_id;
  referee_uid;
  referrer_type;
  id;
}
class PlayerReferralService extends EntityBaseGqlService {
  _mutationBuilder;
  constructor(client, messageLocalizer) {
    const builder = new PlayerReferralRequestBuilder();
    super(client, builder, messageLocalizer);
    this._mutationBuilder = builder;
  }
  getErrorSeverity(_code) {
    return 0;
  }
  get(requestPayload) {
    return this.fetchData(requestPayload).pipe(
      map(({ responsePayload, ...response }) => {
        const resp = responsePayload?.getPlayerReferrals;
        return {
          ...response,
          requestPayload,
          responsePayload: resp?.items?.length ? {
            items: resp?.items,
            total: resp?.total_count
          } : { items: [], total: 0 }
        };
      })
    );
  }
  addReferrerInfo(referrer) {
    return this._service.mutate(this._mutationBuilder.getAddReferrerMutation(), {
      referral: {
        referrer_id: referrer.referrer_id,
        referee_uid: referrer.referee_uid
      }
    }).pipe(map((r) => ({ ...r, responsePayload: r.responsePayload?.addReferrer })));
  }
  updateReferrerInfo(referrer) {
    return this._service.mutate(this._mutationBuilder.getUpdateReferrerInfoMutation(), {
      referral: {
        referrer_id: referrer.referrer_id,
        referee_uid: referrer.referee_uid
      }
    }).pipe(map((r) => ({ ...r, requestPayload: referrer, responsePayload: r.responsePayload?.updateReferrer })));
  }
  removeReferrerInfo(referrer) {
    return this._service.mutate(this._mutationBuilder.getRemoveReferrerInfoMutation(), {
      referral: {
        referrer_id: referrer.referrer_id,
        referee_uid: referrer.referee_uid
      }
    }).pipe(map((r) => ({ ...r, responsePayload: r.responsePayload?.removeReferrer })));
  }
  editExpirationDate({ expiration_date, referee_uid }) {
    const referral = {
      uid: referee_uid,
      update_type: ReferralAmountUpdateType.Percentage,
      expiration_date
    };
    return this._service.mutate(
      this._mutationBuilder.getUpdateRegularPlayerReferralSettingsMutation(),
      {
        referral
      }
    ).pipe(map((r) => ({ ...r, responsePayload: r.responsePayload?.updateRegularPlayerReferralSettings })));
  }
  editRevenueShare({ revenue_share, referee_uid }) {
    const referral = {
      uid: referee_uid,
      update_type: ReferralAmountUpdateType.Percentage,
      revenue_share
    };
    return this._service.mutate(
      this._mutationBuilder.getUpdateRegularPlayerReferralSettingsMutation(),
      {
        referral
      }
    ).pipe(map((r) => ({ ...r, responsePayload: r.responsePayload?.updateRegularPlayerReferralSettings })));
  }
}
export {
  PlayerReferralService,
  ReferrerType,
  UserReferralFormModel
};
//# sourceMappingURL=service.js.map
